<script setup>
    import { storeToRefs } from 'pinia';
    import { useUserStore } from "@/store/modules/user";

    const userStore 	= useUserStore();
    const { isLogin,user } = storeToRefs(userStore);

    const props = defineProps({
        data: {
            type: [Object,Array],
            default: {}
        }
    })
    
    const logout = ()=>{
        userStore.logout();
    }
    
</script>

<template>
    <div class="top-wrap" :style="{ height: props.data.height_style + 'px', backgroundColor: props.data.background_color, borderColor: props.data.border_color }">
        
        <div class="top-box" :style="{ color: props.data.text_color }">
            <div class="left" v-if="props.data.data[0] != undefined">
                <template v-if="!isLogin">
                    <span>{{ props.data.data[0].tips || "" }}</span>
                    <span v-for="(value,index) in props.data.data[0].list" :key="index"><a-link :to="value.link.path">{{ value.title || "" }}</a-link></span>
                </template>
                <template v-else-if="user != null">
                    <span><a-link to="/ucenter/index">欢迎回来，{{ user.username || "" }}</a-link></span>
                    <span style="margin-left: 20px;" @click="logout">退出</span>
                </template>
            </div>

            <div class="right" v-if="props.data.data[1] != undefined">
                <span v-for="(value,index) in props.data.data[1].list" :key="index">
                    <a-link :to="value.link.path">{{ value.title || "" }}</a-link>
                </span>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.top-wrap {
    height: 36px;
    line-height: 36px;
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    align-items: center;
    background-color: #fff;
    .top-box {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        font-size: 13px;
        color: #333;
        .left {
            span {
                margin-left: 30px;
                cursor: pointer;
                &:hover {
                    color: #dc143c;
                }
                a {
                    color: #333;
                    text-decoration: none;
                    font-size: 13px;
                    &:hover {
                        color: #dc143c;
                    }
                }
                &:first-child {
                    margin-left: 0;
                }
            }
        }
        .right {
            span {
                margin-right: 30px;
                a {
                    color: #333;
                    text-decoration: none;
                    font-size: 13px;
                    &:hover {
                        color: #dc143c;
                    }
                }
                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
}
</style>